export default __webpack_public_path__ + "static/media/Group 36.015807a5.png";